import React, { useEffect, useState } from 'react'
import { Button, Row, Col } from 'react-bootstrap'
import './timepicker-custom-styles.css'

import classNames from 'classnames/bind'

import { formatTime } from './InitialTimes'
import dayjs from 'dayjs'
const TimePickerCustom = ({
  value,
  onChange,
  formatDisplay,
  ampm,
  onClose = () => {},
  timeValue,
  setTimeValue = () => {},
  convertTime = () => {},
  ...props
}) => {
  const [views, setViews] = useState({
    hour: true,
    minute: true,
    second: true,
    close: 'second',
  })

  const n = (n) => {
    return n > 9 ? '' + n : '0' + n
  }

  const handleClick = (type, value) => {
    let dateDefault = dayjs().format('YYYY-MM-DD')
    let timeDefault = convertTime(
      `${dateDefault} ${timeValue}`,
      ampm ? 'hh:mm:ss' : 'HH:mm:ss'
    )
    let listTime = timeValue ? timeDefault.split(':') : '00:00:00'.split(':')
    if (type === 'hour') {
      listTime[0] = n(value)
    } else if (type === 'minute') {
      listTime[1] = n(value)
    } else if (type === 'second') {
      listTime[2] = n(value)
    }
    let newTime = listTime.join(':')
    if (ampm) {
      let ampmValue =
        type === 'ampm'
          ? value
          : convertTime(`${dateDefault} ${timeValue}`, 'A')
      newTime = `${newTime} ${ampmValue}`
    }
    setTimeValue(newTime)

    if (onChange) {
      onChange(newTime)
    }
    if (type === views.close && listTime[0] > 0) {
      onClose()
    }
  }

  const parseTime = (type) => {
    if (typeof timeValue !== 'string') return ''
    let dateDefault = dayjs().format('YYYY-MM-DD')
    let timeDefault = convertTime(`${dateDefault} ${timeValue}`, formatDisplay)
    const time = timeDefault.trim()
    const ampmMatch = time.match(/\s?(AM|PM)$/i)
    let mainTime = time
    let ampm = ''

    // ถ้ามี AM/PM ให้ตัดออก
    if (ampmMatch) {
      ampm = ampmMatch[1].toUpperCase()
      mainTime = time.replace(/\s?(AM|PM)$/i, '')
    }

    const parts = mainTime.split(':')
    if (parts.length === 0) return ''
    const [hour, minute, second] = parts
    switch (type) {
      case 'hour':
        return hour
      case 'minute':
        return minute
      case 'second':
        return second
      case 'ampm':
        return ampm
      default:
        return ''
    }
  }

  useEffect(() => {
    let viewHMS = /(hh:mm:ss|HH:mm:ss)/
    let viewHM = /(hh:mm|HH:mm)/
    let viewMS = /(mm:ss)/
    let viewH = /(hh|HH)/
    let viewM = /(mm)/
    let viewS = /(ss)/
    if (viewHMS.test(formatDisplay)) {
      setViews({
        hour: true,
        minute: true,
        second: true,
        close: ampm ? 'ampm' : 'second',
      })
    } else if (viewHM.test(formatDisplay)) {
      setViews({
        hour: true,
        minute: true,
        second: false,
        close: ampm ? 'ampm' : 'minute',
      })
    } else if (viewMS.test(formatDisplay)) {
      setViews({
        hour: false,
        minute: true,
        second: true,
        close: ampm ? 'ampm' : 'second',
      })
    } else if (viewH.test(formatDisplay)) {
      setViews({
        hour: true,
        minute: false,
        second: false,
        close: ampm ? 'ampm' : 'hour',
      })
    } else if (viewM.test(formatDisplay)) {
      setViews({
        hour: false,
        minute: true,
        second: false,
        close: ampm ? 'ampm' : 'minute',
      })
    } else if (viewS.test(formatDisplay)) {
      setViews({
        hour: false,
        minute: false,
        second: true,
        close: ampm ? 'ampm' : 'second',
      })
    } else {
      setViews({
        hour: true,
        minute: true,
        second: true,
        close: ampm ? 'ampm' : 'second',
      })
    }
  }, [formatDisplay, ampm])

  return (
    <Row style={{ maxWidth: 350 }}>
      {views?.hour && (
        <Col xs="8">
          <Row>
            <Col xs="12">
              <div className="position-relative">
                <div className="time-head">
                  <span>Hour</span>
                </div>

                <Button
                  variant="outline-secondary now-calendar-btn"
                  onClick={() => {
                    setTimeValue(convertTime(new Date(), formatDisplay))
                    if (onChange) {
                      onChange(convertTime(new Date(), formatDisplay))
                      onClose()
                    }
                  }}
                >
                  Now
                </Button>
              </div>
            </Col>
            <Col xs="12">
              <Row className="p-2">
                {new Array(ampm ? 13 : 24)
                  .fill(0, ampm ? 1 : 0)
                  .map((_, hour) => (
                    <Col xs="2" className="p-0 text-center">
                      <Button
                        variant={classNames(
                          {
                            'outline-secondary':
                              parseTime('hour') !==
                              hour.toString().padStart(2, '0'),
                            secondary:
                              parseTime('hour') ===
                              hour.toString().padStart(2, '0'),
                          },
                          'number-btn'
                        )}
                        className="text-center"
                        onClick={() => handleClick('hour', hour)}
                      >
                        {hour}
                      </Button>
                    </Col>
                  ))}
              </Row>
            </Col>
          </Row>
        </Col>
      )}
      {views?.minute && (
        <Col xs="4">
          <Row>
            <Col xs="12">
              <div className="time-head">
                <span>Minute</span>
              </div>
            </Col>
            <Col xs="12">
              <Row className="p-2">
                {new Array(12).fill(0).map((_, minute) => (
                  <Col xs="4" className="p-0 text-center">
                    <Button
                      variant={classNames(
                        {
                          'outline-secondary':
                            parseTime('minute') !==
                            (minute * 5).toString().padStart(2, '0'),
                          secondary:
                            parseTime('minute') ===
                            (minute * 5).toString().padStart(2, '0'),
                        },
                        'number-btn'
                      )}
                      className="text-center"
                      onClick={() => handleClick('minute', minute * 5)}
                    >
                      {minute * 5}
                    </Button>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Col>
      )}
      {ampm && (
        <Col xs="12" className="row w-100 mx-auto px-0 mb-2">
          <Col xs="6">
            <Button
              variant={classNames({
                'outline-secondary': parseTime('ampm') !== 'AM',
                secondary: parseTime('ampm') === 'AM',
              })}
              className="w-100 p-0 px-1"
              onClick={() => handleClick('ampm', 'AM')}
            >
              AM
            </Button>
          </Col>
          <Col xs="6">
            <Button
              variant={classNames({
                'outline-secondary': parseTime('ampm') !== 'PM',
                secondary: parseTime('ampm') === 'PM',
              })}
              className="w-100 p-0 px-1"
              onClick={() => handleClick('ampm', 'PM')}
            >
              PM
            </Button>
          </Col>
        </Col>
      )}
    </Row>
  )
}

export default TimePickerCustom
